<template>
<div class="login-page">
<div class="login-box">
  <div class="login-img">
    <img src="static/img/loginimg.jpg" />
  </div>
  <div class="login-boxcont">
    <div class="title">Prijavite se</div>
    <p class="error" v-if="error">{{ error }}</p>
    <form class="login-form" v-on:submit.prevent="doLogin">
      <div class="form-f">
        <label>Korisničko ime:</label>
        <input :readonly="authFactors.length" type="text" class="form-field" v-model="form.username" ref="usernameField" />
      </div>
      <AutoSlot slotType="loginFactors" :authData="form.authData" :authFactors="authFactors" />
      <div class="form-act" v-if="!authFactors.length">
        <button class="">Dalje</button>
      </div>
      <div class="form-act" v-else>
        <a href="" class="forgot">Zaboravili ste lozinku?</a>
        <button class="">Prijava</button>
      </div>
    </form>
  </div>
</div>
</div>
</template>

<script>
import api from '@/Util/api';

export default {
  data: ()=>({
    form: {
      username: "",
      authData: {},
    },
    authFactors: [],
    error: null,
  }),
  methods: {
    async getAuthFactors(username) {
      var response=await api.doLogin(username);
      this.error=response.error || null;
      this.authFactors=response.factors || [];
    },
    async doLogin() {
      if (!this.authFactors.length) {
        this.getAuthFactors(this.form.username);
      } else {
        var response=await api.doLogin(this.form.username, this.form.authData);
        this.error=response.error || null;
        if (response.success) {
          await this.stores.auth.login(response.token);
          this.$router.push({name: "page", params: {path: []}});
        }
      }
    },
  },
  mounted() {
    this.$refs.usernameField.focus();
  },
}
</script>
